import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: ':mapId/event/:eventId/ticket/:ticketTypeId',
    loadChildren: () => import('./maps/maps.module').then((m) => m.MapsModule)
  },
  {
    path: 'evento/:eventId/sector/:ticketTypeId',
    loadChildren: () => import('./maps/maps.module').then((m) => m.MapsModule)
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
